<template>
	<div>
		<!-- <label v-for="(b,bindex) in handlerlist" :key="bindex" style="margin-left:5px;margin-top: 15px;"> -->
			<el-button size="mini" :type="b.type" :icon="b.icon" @click.native="handle(b.event,b.l_id,b.title,b.l_tablename)" v-for="(b,bindex) in handlerlist" :key="bindex" style="margin-left:5px;margin-top: 5px;">{{b.title}}</el-button>
			
			<!-- 发票交付按钮 -->
			<!-- <el-popover
			  placement="right-start"
			  width="160" v-if="b.l_tabevent==1"
			  v-model="visible">
			  <p>这是一段内容这是一段内容确定删除吗？</p>
			  <div style="text-align: right; margin: 0">  
			  </div>
			  <el-button slot="reference" size="mini" :type="b.type" :icon="b.icon">{{b.title}}</el-button>
			</el-popover> -->
		<!-- </label> -->
	</div>
</template>

<script>
export default {
	props: {
		handlerlist: {
			type: Array,
			default: []
		}
	},
	methods: {
		//操作栏按钮单击事件
		handle(event,l_id,title,l_tablename) {
			this.$emit('buttonhandle', 
			{ 
				event: event,
				l_id:l_id,
				l_name:title,
				l_tablename:l_tablename
			});
		}
	}
};
</script>

<style>
</style>
